import { appCopy } from "helpers/appCopy";
import * as R from "ramda";
import React from "react";

export function text(params, ...rest) {
  const path = R.split(".")(params);
  const str = R.path(path)(appCopy) || "";
  const values = [...rest];
  if (values && values.map) {
    return values.reduce((acc, val, i) => acc.replace(`$_${i + 1}`, val), str);
  }
  return str;
}
function Text({ bundle }) {
  const t = text(bundle);
  return <>{t}</>;
}
export default Text;

export function Pills({ text, block, className }) {
  return (
    <span
      data-testid="pill"
      className={`mx-1 py-1 px-2 bg-cool-grey d-inline-block ${block ? "rounded" : "round"} ${className || ""}`}
      style={{ whiteSpace: "normal", minWidth: block && "15rem" }}
    >
      {text}
    </span>
  );
}
